
import { SourceObjectTypeEnum } from "src/app/core/enums/accounting/source-object-type-enum";
import { TargetObjectTypeEnum } from "src/app/core/enums/accounting/target-object-type-enum";
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { GlobalComponent } from "src/app/global-component";

export class AccountingMappingRulesConfig extends TableConfigurationModel {

    constructor() {
        super();
        this.listTitle = "Objects";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {
                dataFieldName: 'sourceObjectType',
                title: 'Source Object Type',
                visible: 'true',
                order: 1,
                width: "175px",
                type: ColumnTypeEnum.InlineEditingDropdown,
                inlineEditingDropDownOptions: [
                    {
                        value: SourceObjectTypeEnum.Category,
                        selectedText: "Category",
                        dropdownText: "Category"
                    },
                    {
                        value: SourceObjectTypeEnum.Customer,
                        selectedText: "Customer",
                        dropdownText: "Customer"
                    },
                    {
                        value: SourceObjectTypeEnum.Tax,
                        selectedText: "Tax",
                        dropdownText: "Tax"
                    },
                    {
                        value: SourceObjectTypeEnum.Requisition,
                        selectedText: "Requisition",
                        dropdownText: "Requisition"
                    },
                    {
                        value: SourceObjectTypeEnum.RequisitionChartOfAccount,
                        selectedText: "Requisition Chart Of Account",
                        dropdownText: "Requisition Chart Of Account"
                    },
                ]
            },
            {
                dataFieldName: 'sourceId',
                title: 'Source Id',
                visible: 'true',
                order: 2,
                width: "175px",
                type: ColumnTypeEnum.InlineEditingString
            },
            {
                dataFieldName: 'sourceName',
                title: 'Source Name',
                visible: 'true',
                order: 3,
                width: "175px",
                type: ColumnTypeEnum.InlineEditingString
            },
            {
                dataFieldName: 'targetObjectType',
                title: 'Target Object Type',
                visible: 'true',
                order: 4,
                width: "175px",
                type: ColumnTypeEnum.InlineEditingDropdown,
                inlineEditingDropDownOptions: [
                    {
                        value: TargetObjectTypeEnum.CustomField,
                        selectedText: "Custom",
                        dropdownText: "Custom"
                    },
                    {
                        value: TargetObjectTypeEnum.ChartOfAccounts,
                        selectedText: "Chart Of Accounts",
                        dropdownText: "Chart Of Accounts"
                    },
                       {
                        value: TargetObjectTypeEnum.BankAccountID,
                        selectedText: "Bank Account ID",
                        dropdownText: "Bank Account ID"
                    },
                    {
                        value: TargetObjectTypeEnum.ProductService,
                        selectedText: "Product Service",
                        dropdownText: "Product Service"
                    },
                    {
                        value: TargetObjectTypeEnum.SalesTax,
                        selectedText: "Sales Tax",
                        dropdownText: "Sales Tax"
                    },
                    {
                        value: SourceObjectTypeEnum.Tax,
                        selectedText: "Tax",
                        dropdownText: "Tax"
                    },
                ]
            },
            {
                dataFieldName: 'targetId',
                title: 'Target Id',
                visible: 'true',
                order: 5,
                width: "175px",
                type: ColumnTypeEnum.InlineEditingString
            },
            {
                dataFieldName: 'targetName',
                title: 'Target Name',
                visible: 'true',
                order: 6,
                width: "175px",
                type: ColumnTypeEnum.InlineEditingString
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 7,
                width: "125px",
                type: ColumnTypeEnum.Action
            },
        ]
        this.filters = undefined;
        this.searchbarFilter = undefined;
        this.actions = [
            {
                visible: 'true',
                label: 'Edit Inline',
                actionId: ActionIdEnum.EnableDisable,
                icon: 'ri-edit-box-line',
                inDropdown: true,
                inList: true,
                visibleOnValues: [0],
                visibilityByValueIsEnum: true,
                dataFieldName: 'enableInLineEditing'
            },
            {
                visible: 'true',
                label: 'Approve Edits',
                actionId: ActionIdEnum.EnableDisable,
                icon: 'ri-checkbox-circle-line',
                inDropdown: true,
                inList: true,
                visibleOnValues: [1],
                visibilityByValueIsEnum: true,
                dataFieldName: 'enableInLineEditing'
            },
            {
                visible: 'true',
                label: 'Delete',
                actionId: ActionIdEnum.Delete,
                icon: 'ri-close-circle-line',
                inDropdown: true,
                inList: true,
                visibleOnValues: [1],
                visibilityByValueIsEnum: true,
                dataFieldName: 'enableInLineEditing'
            },
        ]
        this.buttons = [
            {
                visible: 'true',
                label: "Create New",
                iconIsAfterLabel: false,
                action: ButtonIdEnum.CreateNew,
                color: "btn-success",
                icon: "ri-add-fill",
                type: ButtonTypeEnum.Default
            },]

        this.enablePagination = false;
    }
}